interface FormInputProps {
  label: string;
  type: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
}

export default function FormInput({
  label,
  type,
  name,
  value,
  onChange,
  placeholder,
  required = false,
  error,
}: FormInputProps) {
  return (
    <div className="w-full">
      <label htmlFor={name} className="block text-sm font-medium text-foreground mb-2">
        {label} {required && <span className="text-error">*</span>}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`w-full px-4 py-3 rounded-lg border transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-accent ${
          error
            ? 'border-error focus:border-error' :'border-input focus:border-accent'
        } bg-card text-foreground placeholder:text-muted-foreground`}
      />
      {error && <p className="mt-1 text-xs text-error">{error}</p>}
    </div>
  );
}